var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ELSLoggingService } from '@els/els-ui-common-react';
import { SESSION_STORAGE_INDEXED_DB_KEY } from 'constants/app.constant';
var DB_NAME = 'programDashboard';
// Generate a unique identifier using crypto API
export var generateStorageId = function () {
    var array = new Uint32Array(4);
    window.crypto.getRandomValues(array);
    return array.join('-');
};
var dbStorageNameFromSession = sessionStorage.getItem(SESSION_STORAGE_INDEXED_DB_KEY);
var STORAGE_NAME = dbStorageNameFromSession || "PD-".concat(generateStorageId());
var dbInstance = null;
export var Stores;
(function (Stores) {
    Stores["ActionState"] = "actionState";
})(Stores || (Stores = {}));
export var initDB = function () {
    return new Promise(function (resolve, reject) {
        var request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = function () {
            var db = request.result;
            if (!db.objectStoreNames.contains(Stores.ActionState)) {
                db.createObjectStore(Stores.ActionState, { keyPath: 'id' });
            }
        };
        request.onsuccess = function () {
            // set session storage to store the storage name
            sessionStorage.setItem(SESSION_STORAGE_INDEXED_DB_KEY, STORAGE_NAME);
            dbInstance = request.result;
            resolve(dbInstance);
            dbInstance.onversionchange = function () {
                dbInstance.close();
            };
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
};
export var addUpdateData = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var transaction = db.transaction(Stores.ActionState, 'readwrite');
                        var store = transaction.objectStore(Stores.ActionState);
                        // Using "put" instead of "add" to update existing data if key exist and add new record if index doesn't exist.
                        var dataWithTimestamp = __assign(__assign({}, data), { timestamp: new Date().getTime(), id: STORAGE_NAME });
                        var request = store.put(dataWithTimestamp);
                        request.onsuccess = function () {
                            db.close();
                            resolve();
                        };
                        request.onerror = function () {
                            db.close();
                            reject(request.error);
                        };
                    })];
        }
    });
}); };
export var getData = function () { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var transaction = db.transaction(Stores.ActionState, 'readonly');
                        var store = transaction.objectStore(Stores.ActionState);
                        var request = store.get(STORAGE_NAME);
                        request.onsuccess = function () {
                            db.close();
                            resolve(request.result);
                        };
                        request.onerror = function () {
                            db.close();
                            reject(request.error);
                        };
                    })];
        }
    });
}); };
var deleteRecord = function (dbStorageKey) { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var transaction = db.transaction(Stores.ActionState, 'readwrite');
                        var store = transaction.objectStore(Stores.ActionState);
                        var request = store.delete(dbStorageKey);
                        request.onsuccess = function () {
                            db.close();
                            resolve();
                        };
                        request.onerror = function () {
                            db.close();
                            reject(request.error);
                        };
                    })];
        }
    });
}); };
export var handleIndexedDBRecordDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
    var dbStorageKeyFromSession;
    return __generator(this, function (_a) {
        dbStorageKeyFromSession = sessionStorage.getItem(SESSION_STORAGE_INDEXED_DB_KEY);
        if (dbStorageKeyFromSession) {
            deleteRecord(dbStorageKeyFromSession).catch(function (error) {
                ELSLoggingService.warn('Error while deleting Record', error);
            });
        }
        return [2 /*return*/];
    });
}); };
// Delete Old Records from IndexedDB
var dbDuration = 12 * 60 * 60 * 1000; // 12 hours
var getAllRecords = function () { return __awaiter(void 0, void 0, Promise, function () {
    var db;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initDB()];
            case 1:
                db = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var transaction = db.transaction(Stores.ActionState, 'readonly');
                        var store = transaction.objectStore(Stores.ActionState);
                        var request = store.getAll();
                        request.onsuccess = function () {
                            db.close();
                            resolve(request.result);
                        };
                        request.onerror = function () {
                            db.close();
                            reject(request.error);
                        };
                    })];
        }
    });
}); };
export var deleteAllOldIndexedDBRecords = function () { return __awaiter(void 0, void 0, void 0, function () {
    var allRecords;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAllRecords()];
            case 1:
                allRecords = _a.sent();
                if (allRecords.length > 0) {
                    allRecords.forEach(function (record) { return __awaiter(void 0, void 0, void 0, function () {
                        var dbRecordTimestamp, timestampDifference;
                        return __generator(this, function (_a) {
                            dbRecordTimestamp = record.timestamp;
                            timestampDifference = new Date().getTime() - dbDuration;
                            if (dbRecordTimestamp && dbRecordTimestamp < timestampDifference) {
                                deleteRecord(record.id).catch(function (error) {
                                    ELSLoggingService.warn('Error while deleting Record', error);
                                });
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
                return [2 /*return*/];
        }
    });
}); };
